"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PLACEHOLDER_IMAGE = exports.DECIMAL_TYPE = exports.CANCELLATION_PENALTY_TYPES = void 0;
var CANCELLATION_PENALTY_TYPES = {
  FULL: 'Full',
  NONE: 'None',
  PARTIAL: 'Partial'
};
exports.CANCELLATION_PENALTY_TYPES = CANCELLATION_PENALTY_TYPES;
var DECIMAL_TYPE = {
  FLOAT: 'FLOAT',
  ROUND: 'ROUND',
  FLOOR: 'FLOOR',
  CEIL: 'CEIL'
};
exports.DECIMAL_TYPE = DECIMAL_TYPE;
var PLACEHOLDER_IMAGE = 'http://static.airasia.com/snap/images/hotel_image_holder.svg';
exports.PLACEHOLDER_IMAGE = PLACEHOLDER_IMAGE;